module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_office_color_skyblue-1ade7a6c3647cb1ee7e8342ea1834ec2.svg";